import { ActionContext, Module } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  TREE_LIST: '/dh-datamaint/subject/listSbjCatalogTree',
  PAGE: '/dh-datamaint/mark/page',
  DELETE: '/dh-datamaint/mark/batchDelete',
  UPDATE: '/dh-datamaint/mark/updateMark'
};

const formatCatalog = function (catalogs: any) {
  let catalogNames = '';

  if (catalogs && catalogs.length > 0) {
    catalogs.forEach((item: any) => {
      catalogNames += item.pathZh + '、';
    })

    catalogNames = catalogNames.substring(0, catalogNames.length - 1);
  }

  return catalogNames;
}

class MarkModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getTreeList(context: ActionContext<any, any>, payload: any) {
      // const res = await ajax.get(URL.TREE_LIST, { params: payload.data });
      // return [{ id: '', nameZh: '全部', children: res.data.data }];
      return await ajax.get(URL.TREE_LIST, { params: payload.data });
    },

    async getPage(context: ActionContext<any, any>, payload: any) {
      const res = await ajax.post(URL.PAGE, payload.data,
        { params: { pageNo: payload.data.pageNo, pageSize: payload.data.pageSize } });

      res.data.records.forEach((item: any) => {
        item.pathZh = item.pathZh || '-';

        if (item.children?.length > 0) {
          item.children.forEach((item2: any) => {
            item2.pathZh = item2.pathZh || '-';
          })
        }
        item._showChildren = true;
      })

      return res;
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, payload.data);
    }
  };
}

export const markModule = new MarkModule();
